import { inject, Injectable } from "@angular/core";
import _compact from "lodash/fp/compact";
import _trimCharsEnd from "lodash/fp/trimCharsEnd";
import _trimCharsStart from "lodash/fp/trimCharsStart";

import { AWSHttpClient } from "@intocare/aws";
import { ENVIRONMENT_TOKEN } from "@intocare/environments";

@Injectable({ providedIn: "root" })
export class AppHttpClient extends AWSHttpClient {
	private readonly env = inject(ENVIRONMENT_TOKEN);

	override makeUrl(path?: string) {
		const basePath = _trimCharsEnd("/", this.env.API.public);
		const callPath = path && _trimCharsStart("/", path);

		return super.makeUrl(_compact([basePath, callPath]).join("/"));
	}
}
